import Common from '../common'
var Js = Common('sku')
export default {
	name: 'sku',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 50
				},
				{
					key: 'sku_no',
					label: 'SKU NO',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 150
				},
				{
					key: 'title',
					label: '规格',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入规格',
						clearable: true,
						defaultValue: '',
						optionsName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.title = val;
							} else {
								delete self.searchItem.title;
							};
						},
					},
				},
				{
					key: 'price',
					label: '价格',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'stock',
					label: '库存',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'sale_count',
					label: '销量',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'listorder',
					label: '排序',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: '',
				},
				{
					key: "status",
					label: '状态',
					application: [],
					componentName: 'sls-select',
					optionsName: 'statusOptions',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.status == 1) {
							return '启用';
						} else {
							return '关闭';
						};
					}
				},
				{
					key: 'mainImg',
					label: '主图',
					customSlot: 'mainImg',
					application: ['编辑', '添加'],
					componentName: 't-upload',
					listType: 'normal',
					limit: 10,
					dialogStyle: 'width:90%',
					width: 100
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					header_search: {
						componentName: 'sls-date-time-range',
						style: 'width:160px;margin-right:2px;',
						start_placeholder: '创建开始时间',
						end_placeholder: '创建结束时间',
						changeFunc: function(value, self) {
							if (!value) {
								delete self.searchItem.create_time;
							} else {
								self.searchItem.create_time = ['between', value = value.map(function(e) {
									return e / 1000;
								})]
							};

						},
					},
					width: 200,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 100
				},
			],
			// 按钮配置
			btn_info: [


				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_skuUpdate"
						},
						formData: function(self) {
							if (self.optionData.sku_item && self.optionData.sku_item.length > 0) {
								for (var i = 0; i < self.optionData.sku_item.length; i++) {
									self.formData[self.optionData.sku_item[i].title] = '';
									for (var c_i = 0; c_i < self.formData.sku.length; c_i++) {
										if (self.formData.sku[c_i].parentid == self.optionData.sku_item[i].id) {
											self.formData[self.optionData.sku_item[i].title] = self.formData
												.sku[c_i].id;
											break;
										};
									};
								};
							};
							return self.formData;
						},
						postData: function(self) {
							self.submitData.sku_item = [];
							if (self.optionData.sku_item && self.optionData.sku_item.length > 0) {
								for (var i = 0; i < self.optionData.sku_item.length; i++) {
									if (self.submitData[self.optionData.sku_item[i].title]) {
										self.submitData.sku_item.push(self.submitData[self.optionData.sku_item[
											i].title])
									} else if (self.formData[self.optionData.sku_item[i].title]) {
										self.submitData.sku_item.push(self.formData[self.optionData.sku_item[i]
											.title])
									};
									delete self.submitData[self.optionData.sku_item[i].title];
								};
							};
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							return postData;
						}
					},
				},
				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {
						apiName: function(self) {
							return "api_skuUpdate"
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
								},
								data: {
									status: -1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					text: function(data) {
						return '添加'
					},
					func: {
						apiName: function(self) {
							return "api_skuAdd"
						},
						formData: function(self) {
							var data = {};
							if (self.optionData.sku_item && self.optionData.sku_item.length > 0) {
								for (var i = 0; i < self.optionData.sku_item.length; i++) {
									data[self.optionData.sku_item[i].title] = '';
								};
							};
							return data;
						},
						postData: function(self) {
							self.submitData.sku_item = [];
							if (self.optionData.sku_item && self.optionData.sku_item.length > 0) {
								for (var i = 0; i < self.optionData.sku_item.length; i++) {
									if (self.submitData[self.optionData.sku_item[i].title]) {
										self.submitData.sku_item.push(self.submitData[self.optionData.sku_item[
											i].title])
									};
									delete self.submitData[self.optionData.sku_item[i].title]
								};
							};
							var postData = {
								data: self.submitData
							};
							postData.saveAfter = [{
								tableName: 'ProductDate',
								FuncName: 'add',
								data: {
									res: {
										sku_no: 'sku_no'
									},
									type: 1,
									is_template: 0,
									stock: self.submitData.stock,
									product_id:self.product_id
								}
							}]
							if (self.product_id) {
								postData.data.product_id = self.product_id;
								return postData;
							} else {
								return false;
							};
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					text: function(data) {
						return '返回'
					},
					funcType: 'func',
					func: {
						func: function(self) {
							self.$router.push(self.path);
						},
					},
				},
			],

			searchItem: {
				thirdapp_id: this.$store.getters.getUserinfo.thirdapp_id
			},
			startSearchItem: {
				thirdapp_id: this.$store.getters.getUserinfo.thirdapp_id
			},
			optionData: {
				skuOptions: [],
				sku_item: [],
				statusOptions: [{
					text: '启用',
					value: 1
				}, {
					text: '禁用',
					value: -1
				}],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			}

		}

	},

	mounted() {
		const self = this;
		self.table_arguments.tree_props = {
			children: 'child',
			child: 'child',
			hasChildren: 'child'
		}
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			const self = this;
			self.product_id = this.$route.params.product_id;
			self.path = this.$route.params.path;
			this.initProductData()
			this.initMainData();
		},


		async initProductData(product_no) {
			const self = this;
			const postData = {};
			postData.searchItem = {
				id: self.product_id
			};
			try {
				var res = await self.$$api_productGet({
					data: postData
				});
			} catch (err) {
				console.log(err);
				notify('网络故障', 'error');
			};

			if (res.info.data.length > 0) {
				self.productInfo = res.info.data[0];
				self.initSkuData(self.productInfo.sku_array);
			} else {
				notify('制定商品不存在', 'error');
			};

		},


		//获取SKU信息
		async initSkuData(sku_array) {
			const self = this;
			const postData = {};
			postData.searchItem = {
				id: ['in', sku_array]
			};
			postData.searchItemOr = {
				parentid: ['in', sku_array]
			};
			postData.token = self.$store.getters.getToken;
			postData.order = {
				listorder: 'desc'
			};

			try {
				var res = await self.$$api_labelGet({
					data: postData
				});
			} catch (err) {
				console.log(err);
				notify('网络故障', 'error');
			};
			self.sku = res.info.data;
			if (self.sku.length > 0) {

				for (var key in self.sku) {
					console.log('item', self.sku[key])
					if (self.sku[key].type == '5') {
						self.optionData[self.sku[key].id + 'Options'] = self.sku[key].children || [];
						self.fields.push({
							key: self.sku[key].title,
							label: self.sku[key].title,
							application: ['添加', '编辑'],
							componentName: 'sls-select',
							optionsName: self.sku[key].id + 'Options',
							listType: '',
							defaultProps: {
								label: 'title',
								value: 'id',
							},
						});
						self.optionData.sku_item.push(self.sku[key]);
						console.log('optionData', self.optionData)
					};
				};
			};

		},

		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			self.table_arguments.loading = true;
			const postData = {};
			if (isNew) {
				self.paginate.currentPage = 1;
			};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			postData.searchItem.product_id = self.product_id;
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			postData.getAfter = {
				sku: {
					tableName: 'Label',
					middleKey: 'sku_item',
					key: 'id',
					condition: 'in',
					searchItem: {
						status: 1
					},
				},
			};

			var res = await self.$$api_skuGet({
				data: postData
			});
			self.mainData = res.info.data;
			self.paginate.count = res.info.total;
			self.table_arguments.loading = false;

		}

	},


}



// WEBPACK FOOTER //
// ./src/views/product/sku.js